import { useState, useEffect } from 'react';
import styled from 'styled-components';
import { toaster } from '../../helpers/toaster';
import { Form, TextInput, Button, Loading } from 'carbon-components-react';
import Select from 'react-select';
import MyModal from '../../components/Modal/Modal';
import { deleteGlobalRegistry } from '../../api/global-registries';

const DeleteGlobalRegistryModal = ({
  open = false,
  refreshList = () => {},
  onClose = () => {},
  globalRegistryList = [],
  deleteItem,
  }) => {
  // loading is for initial component preloading
  const [loading, setLoading] = useState(false);
  // processing is for user initiated component api calls
  const [processing, setProcessing] = useState(false);
  const [newGlobalRegistry, setNewGlobalRegistry] = useState("");
  const [selectArray, setSelectArray] = useState([]);
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    let buildSelectArray = [];
    for(let x = 0; x < globalRegistryList?.length; x++){
      if(globalRegistryList[x] !== deleteItem){
        buildSelectArray.push({
          label: globalRegistryList[x].name,
          value: globalRegistryList[x].id
        });
      }
    }
    setSelectArray(buildSelectArray);
  }, [globalRegistryList, deleteItem]);

  const addBtnStyle = {
    padding: "11px 18px",
    height: "auto",
    minHeight: "unset",
    borderRadius: "10px",
    fontFamily: "'Plus Jakarta Sans', system-ui, sans-serif",
    fontWeight: 700,
    fontSize: "13.5px",
    width: "fit-content",
    marginLeft: "10px",
  };
  const onGlobalRegistrySelect = item => {
    setNewGlobalRegistry(item);
    setDisabled(false);
  };

  const deleteRegistry = (e) => {
    e.preventDefault();
    
    if (!newGlobalRegistry) {
      toaster("Please choose a global registry", "warning")
      return;
    }
    
    setProcessing(true);
    deleteGlobalRegistry(deleteItem.id, {global_registry: newGlobalRegistry.value})
    .then(res => {
      toaster("Global registry deleted successfully", "success")
      setNewGlobalRegistry("");
      setDisabled(true);
      onClose();
      refreshList();
      setProcessing(false);
    }).catch(error => {
      toaster("Could not delete global registry", "error")
      setProcessing(false);
    });
  };

  const additionalProps = {
    className: 'some-class',
    onSubmit: deleteRegistry
  };

  return (
    <MyModal
      modalHeading="Delete Global Registry"
      size="sm"
      open={open}
      onRequestClose={() => {
        onClose();
        setNewGlobalRegistry("");
        setDisabled(true);
      }}
    >
      <ModalContent>
      
      {
          processing || loading ? 
          <Loading/> 
          :
          <></>
        }
        <ConfirmText style={{ marginBottom: "18px" }}>{`Select a different global registry to reassign all registries connected to ${deleteItem?.name}.`}</ConfirmText>
        <Form {...additionalProps}>
          <div style={{ marginBottom: "128px" }}>
            <Select 
              options={selectArray} 
              onChange={e => onGlobalRegistrySelect(e)}
              value={newGlobalRegistry} 
              classNamePrefix="xogene"
              className="basic-single"
              required
              />
          </div>

          <ModalFooter>

          <Button 
              kind="secondary"
              onClick={() => {
                onClose();
                setNewGlobalRegistry("");
                setDisabled(true);
              }}
              style={addBtnStyle}  
            >Cancel</Button>

            <Button
              type="submit"
              kind="danger"
              disabled={disabled}
              // onClick={() => onCreate()}
              style={addBtnStyle}  
            >Yes</Button>
          </ModalFooter>

        </Form>

      </ModalContent>
    </MyModal>
  );
};

export default DeleteGlobalRegistryModal;

const ModalContent = styled.div`
display: flex;
flex-direction: column;
`

const ModalFooter = styled.div`
width: 100%;
display: flex;
justify-content: flex-end;
`
const ConfirmText = styled.div`
`
